import { ID, Logger } from "@kosmod/kit";
import { Shape } from "@kosmod/pancake";
import { Component, Ref } from "@lukekaalim/act";

import * as three from 'three';

import { ToolController } from "../../hooks/useToolController";
import { TheatreState } from "../../hooks/useTheatreState";
import { TheatrePosition } from "../../defs/position";
import { TheatreSelectionController } from "../../hooks/useTheatreSelection";
import { TheatreController, TheatreData, Tool, ToolKey } from "../..";

import { ToolDefinition, ToolStateOf } from "../../defs/tools/define";

export const defineToolHandler = <const T extends ToolDefinition, const D extends ToolHandler<T>>(tool: T, definition: D) => {
  definedToolHandlers.set(tool.key, definition as ToolHandler);
  return definition;
}

export const definedToolHandlers = new Map<string, ToolHandler>()


export type ToolHandler<D extends ToolDefinition = any> = {
  def: D,
  
  /** The default onSelect handler sets the ActiveTool to this tool's ID */
  onSelect?: (
    state: ToolStateOf<D>,
    tools: ToolController,
    selection: TheatreSelectionController,
    logger: Logger,
    controller: TheatreController,
    data: TheatreData,
  ) => void | boolean,

  onInput?: (
    event:
      | { type: 'mouse', button: 'primary' | 'secondary', event: MouseEvent }
      | { type: 'wheel', event: WheelEvent }
      | { type: 'keyboard', code: string },
    state: ToolStateOf<D>,
    theatre: TheatreState,
    logger: Logger,
    eventNative: MouseEvent | KeyboardEvent
  ) => void,

  onUpdate?: (
    state: ToolStateOf<D>,
    theatre: TheatreState,
  ) => void,

  PreviewComponent?: ToolPreviewComponentOf<D>,
  ToolbeltComponent?: Component<{
    beltSlotIndex: number,
    toolState: ToolStateOf<D>,
    theatre: TheatreState,
  }>,
}


export type ToolPreviewComponentOf<D extends ToolDefinition> = Component<{
  toolState: ToolStateOf<D>,
  theatre: TheatreState,

  material?: three.Material,
  cursorPosition: Ref<null | TheatrePosition>,
}>;


export const getHandlerForTool = <T extends ToolKey>(key: T): ToolHandler<Extract<Tool, { key: T }>> | null => {
  return definedToolHandlers.get(key) || null as ToolHandler<Extract<Tool, { key: T }>> | null;
}